import { RevenueTier, serializeRevenueTier } from './RevenueTier'

export const makeClient = ({
  id,
  name,
  config,
  feed,
  locale,
  own_paymentsystem: ownPaymentSystem,
  revenue_share,
  revenue_tiers,
  store_group_id: storeGroup,
  created_at: created,
  updated_at: updated,
  default_verified_users: defaultVerifiedUsers,
  user_mail_config: userMailConfig,
  payment_organization_id: paymentOrgId,
  default_revenue_tier,
}) => ({
  id,
  name,
  config,
  feed,
  locale,
  ownPaymentSystem: !!ownPaymentSystem,
  revenue: {
    share: revenue_share < 1 ? `${revenue_share * 100}%` : `${parseInt(revenue_share)}%`,
    tiers: revenue_tiers.map((tier, i) =>
      RevenueTier(
        i,
        tier.id,
        tier.name,
        tier.revenue_share,
        tier.instagram_revenue_share,
        tier.id == default_revenue_tier,
        tier.validates_users ? true : false,
      ),
    ),
  },
  storeGroup: storeGroup == null ? -1 : storeGroup,
  created,
  updated,
  defaultVerifiedUsers: !!defaultVerifiedUsers,
  userMailConfig: userMailConfig || {},
  paymentOrgId,
})

export const serializeClient = ({
  id,
  name,
  config,
  feed,
  locale,
  ownPaymentSystem,
  revenue,
  storeGroup,
  created,
  updated,
  defaultVerifiedUsers,
  userMailConfig,
  paymentOrgId,
}) => ({
  id,
  name,
  config,
  feed,
  locale,
  own_paymentsystem: ownPaymentSystem ? 1 : 0,
  revenue_share: parseFloat(revenue.share) / 100,
  revenue_tiers: revenue.tiers.map((tire) => serializeRevenueTier(tire)),
  store_group_id: parseInt(storeGroup, 10),
  created_at: created,
  updated_at: updated,
  default_verified_users: defaultVerifiedUsers ? 1 : 0,
  user_mail_config: Object.keys(userMailConfig)
    .filter((key) => userMailConfig[key] != '')
    .reduce((res, key) => ((res[key] = userMailConfig[key]), res), {}),
  payment_organization_id: paymentOrgId,
  default_revenue_tier: revenue.tiers.filter((tire) => tire.default).reduce((accumulator, currentValue) => currentValue.remoteId, null),
})
